module.exports = __webpack_public_path__ + "img/13-end_v8e_loading.45402055.jpg";